// extracted by mini-css-extract-plugin
export default {"banner":"Navbar_banner__NJIkF","sticky":"Navbar_sticky__OuDOx","text":"Navbar_text__HpwZp","scrollDown":"Navbar_scrollDown__I-FV1","bounce":"Navbar_bounce__Lbed-"};